import { render, staticRenderFns } from "./zfmima.vue?vue&type=template&id=771684a8&scoped=true"
import script from "./zfmima.vue?vue&type=script&lang=js"
export * from "./zfmima.vue?vue&type=script&lang=js"
import style0 from "./zfmima.vue?vue&type=style&index=0&id=771684a8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "771684a8",
  null
  
)

export default component.exports